"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _colors = require("./colors");
var Colors = {
  hover: _colors.FullPalette.IRIS_E25,
  selected: _colors.FullPalette.GREY_E500,
  error: _colors.FullPalette.POPPY_600
};
var Spacing = {
  0: '0px',
  0.25: '2px',
  0.5: '4px',
  1: '8px',
  1.5: '12px',
  2: '16px',
  2.5: '20px',
  3: '24px',
  4: '32px',
  5: '40px',
  6: '48px',
  8: '64px'
};
var Tokens = {
  colors: Colors,
  spacing: Spacing
};
var _default = exports["default"] = Tokens;